/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_I1Inputs */

const tr_kullanim_s14_i1 = /** @type {(inputs: Kullanim_S14_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik bedelinin ödenmemesi (7 günlük gecikme sonrası ihtarname ile)`)
};

const en_kullanim_s14_i1 = /** @type {(inputs: Kullanim_S14_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-payment of the subscription fee (after 7 days of delay, with a formal notice)`)
};

const de_kullanim_s14_i1 = /** @type {(inputs: Kullanim_S14_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichtzahlung des Abonnemententgelts (nach 7 Tagen Verzug mit Mahnschreiben)`)
};

const ru_kullanim_s14_i1 = /** @type {(inputs: Kullanim_S14_I1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуплата абонентской платы (после 7 дней просрочки, с направлением уведомления)`)
};

/**
* | output |
* | --- |
* | "Non-payment of the subscription fee (after 7 days of delay, with a formal notice)" |
*
* @param {Kullanim_S14_I1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_i1 = /** @type {((inputs?: Kullanim_S14_I1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_I1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_i1(inputs)
	if (locale === "de") return de_kullanim_s14_i1(inputs)
	if (locale === "ru") return ru_kullanim_s14_i1(inputs)
	return tr_kullanim_s14_i1(inputs)
});